import PlusIcon from '@/assets/icons/icon-plus.svg'
import type { SelectOptionsType } from '@/components/ui/form/FormSelect'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import MinusIcon from '@/modules/chatting/icons/minus.svg'
import { classNames } from '@/utils/helpers'

interface Props {
  options: SelectOptionsType
  value: string
  onChange: (value: string) => void
}

export const SelectWithControls = ({ options, value, onChange }: Props) => {
  const currentOptionIndex = options.findIndex(
    (option) => option.value === value,
  )
  const lastOptionIndex = options.length - 1
  const handleClickMinus = () => {
    if (currentOptionIndex > 0) {
      onChange(options[currentOptionIndex - 1].value)
    }
  }

  const handleClickPlus = () => {
    if (currentOptionIndex < lastOptionIndex) {
      onChange(options[currentOptionIndex + 1].value)
    }
  }

  return (
    <div className="flex items-center gap-2">
      <MinusIcon
        className={classNames(
          'w-5 shrink-0 cursor-pointer',
          currentOptionIndex === 0 && 'pointer-events-none opacity-50',
        )}
        onClick={handleClickMinus}
      />
      <Select
        value={value}
        onValueChange={onChange}
      >
        <SelectTrigger className="w-[100px] sm:w-[120px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="max-h-[200px]">
          {options.map(({ label, value }) => (
            <SelectItem
              key={value}
              value={value}
            >
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <PlusIcon
        className={classNames(
          'w-5 shrink-0 cursor-pointer',
          currentOptionIndex === lastOptionIndex &&
            'pointer-events-none opacity-50',
        )}
        onClick={handleClickPlus}
      />
    </div>
  )
}
